<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div>
          <button @click="back" class="btn btn-sm btn-outline-secondary mb-2">
            <i class="mdi mdi-arrow-left mr-1"></i>{{ $t('common.back') }}
          </button>
          <h2 class="text-white font-weight-bold mb-1">{{ $t('superadmin.createPackage') }}</h2>
          <p class="text-muted small mb-0">{{ $t('superadmin.packagesSubtitle') }}</p>
        </div>
      </div>
    </div>

    <div class="col-12 grid-margin">
      <div class="card border-0 shadow-sm" style="background: #191c24; border-radius: 12px;">
        <div class="card-body p-4">
          <form class="forms-sample" @submit.prevent="submitForm">
            <div class="row mb-3">
              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="package_name">
                  {{ $t('superadmin.packageName') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-cube-outline"></i></span>
                  </div>
                  <input
                    id="package_name"
                    type="text"
                    class="form-control bg-dark text-white border-secondary"
                    v-model="packageStore.package_name"
                    :placeholder="$currentLocale === 'id' ? 'Contoh: Enterprise Growth Tier' : 'e.g. Enterprise Growth Tier'"
                    required
                  />
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="price">
                  {{ $t('superadmin.pricePerSeatMonth') }} (IDR) <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted">Rp</span>
                  </div>
                  <input
                    id="price"
                    type="number"
                    class="form-control bg-dark text-white border-secondary"
                    v-model.number="packageStore.price_per_person_per_month"
                    placeholder="50000"
                    min="0"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="limit_user">
                  {{ $t('superadmin.maxUserSeats') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-account-multiple"></i></span>
                  </div>
                  <input
                    id="limit_user"
                    type="number"
                    class="form-control bg-dark text-white border-secondary"
                    v-model.number="packageStore.limit_user"
                    placeholder="100"
                    min="1"
                    required
                  />
                </div>
                <small class="text-muted">{{ $currentLocale === 'id' ? 'Jumlah maksimum karyawan/pemain yang diizinkan untuk perusahaan mitra pada paket ini.' : 'Maximum number of employees/players allowed for client companies on this plan.' }}</small>
              </div>

              <div class="col-12 mb-3">
                <label class="text-light small font-weight-bold" for="description">
                  {{ $t('superadmin.packageDescription') }}
                </label>
                <textarea
                  id="description"
                  class="form-control bg-dark text-white border-secondary"
                  v-model="packageStore.description"
                  rows="4"
                  :placeholder="$currentLocale === 'id' ? 'Ringkas fitur paket, tingkat dukungan layanan, dan kuota kustom...' : 'Summarize plan features, support level, and custom domain allowances...'"
                ></textarea>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex justify-content-end align-items-center pt-3 border-top border-secondary">
              <button
                type="button"
                @click="back"
                class="btn btn-outline-secondary px-4 py-2 mr-3"
                :disabled="loading"
              >
                {{ $t('common.cancel') }}
              </button>
              <button
                type="submit"
                class="btn btn-warning px-5 py-2 font-weight-bold text-dark"
                :disabled="loading"
              >
                <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                <i v-else class="mdi mdi-check-circle-outline mr-1"></i>
                {{ loading ? $t('common.saving') : $t('common.submit') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { storePackage } from '@/services/packageService';
import Swal from 'sweetalert2';

export default {
  name: 'CreatePackageView',
  data() {
    return {
      packageStore: {
        package_name: '',
        price_per_person_per_month: '',
        description: '',
        limit_user: 50,
      },
      loading: false,
    };
  },
  methods: {
    async submitForm() {
      this.loading = true;
      try {
        await storePackage(this.packageStore);

        Swal.fire({
          icon: 'success',
          title: this.$t('common.success'),
          text: this.$currentLocale === 'id' ? 'Paket langganan berhasil dibuat.' : 'Subscription plan created successfully.',
          confirmButtonColor: '#ffab00',
        });

        this.$router.push({ name: 'ListPackage' });
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: this.$t('common.error'),
          text: err.response?.data?.message || err.message || (this.$currentLocale === 'id' ? 'Gagal membuat paket' : 'Failed to create package'),
          confirmButtonColor: '#ffab00',
        });
      } finally {
        this.loading = false;
      }
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
